export const MAX_BP_HISTORY = 30;

export enum BPSortMode {
  LastFired = 'admin.last-fired',
  Machine = 'common.machine',
  Team = 'common.team',
}
